import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import createImgURI from "common/utils/createImgURI"
import { formatCurrency } from "common/utils/currency"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { newDocumentoSelector } from "../../redux/selectors/newDocumentoSelectors"

const ArticulosSelected = ({
  title,
  agregarCantidad,
  setCantidad,
  handleGenerarPresupuesto,
  sinValorar,
  removeArticulo,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { conceptos, subtotal } = useSelector(newDocumentoSelector)

  return (
    <>
      <div
        style={{ minHeight: "600px" }}
        className='w-full p-4 overflow-auto bg-bone max-h-60 position-relative'
      >
        {!conceptos?.length && (
          <h5
            className='text-center position-absolute'
            style={{
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            {t("crear.facturaRec.noSelectedList")}
          </h5>
        )}

        {conceptos?.map(
          (item: $TSMigrationFixMe, i: $TSMigrationFixMe) =>
            item.cantidad > 0 && (
              <div
                key={item.id}
                className={`bg-white shadow-sm rounded-8 flex justify-start p-4 ${
                  i === 0 ? "" : "mt-2"
                }`}
              >
                <div className='w-12 d-flex align-items-center justify-content-center'>
                  {item.thumbnailBase64 === null ? (
                    <FontAwesomeIcon
                      icon={["fal", "camera-slash"]}
                      className='icon-size-lg'
                    />
                  ) : (
                    <img
                      src={createImgURI(
                        item.thumbnailBase64,
                        item.thumbnailMediaType
                      )}
                      alt='imagen'
                      className='object-fit'
                    />
                  )}
                </div>

                <div className='w-full ml-4'>
                  <div className='w-full'>
                    <span className='text-gedesco'>
                      #{item.numeroReferencia}
                    </span>{" "}
                    <span>{item.concepto}</span>
                  </div>

                  <div className='mt-3 w-100 justify-content-between align-items-end d-flex'>
                    <div className='d-flex align-items-center'>
                      <div
                        onClick={() =>
                          agregarCantidad({ articulo: item, sum: -1 })
                        }
                        className='flex items-center justify-center py-2 rounded-l shadow-sm w-1-4 border-1 border-gray pointer'
                      >
                        <FontAwesomeIcon
                          className='icon-size-lg'
                          icon={["fal", "minus"]}
                        />
                      </div>

                      <input
                        value={item.cantidad}
                        onChange={(e) =>
                          setCantidad({
                            articulo: item,
                            cantidad: e.target.value,
                          })
                        }
                        type='number'
                        className='flex items-center justify-center py-2 text-center outarrows w-2-4 bg-bone border-gray border-1'
                      />

                      <div
                        className='flex items-center justify-center py-2 rounded-r shadow-sm w-1-4 border-1 border-gray pointer'
                        onClick={() => agregarCantidad({ articulo: item })}
                      >
                        <FontAwesomeIcon
                          icon={["fal", "plus"]}
                          className='icon-size-lg'
                        />
                      </div>

                      <div>
                        <span
                          onClick={() => removeArticulo(item)}
                          className='ml-3 text-gedesco underline-onhover pointer'
                        >
                          {t("crear.facturaRec.deleteButton")}
                        </span>
                      </div>
                    </div>

                    {!sinValorar && (
                      <div className='d-flex align-items-end'>
                        <div className='mr-1'>
                          <span>{t("crear.facturaRec.priceLabel")}</span>
                        </div>

                        <b className='text-21'>
                          {formatCurrency(item.precioVenta)}
                        </b>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
        )}
      </div>

      <div className='flex items-center justify-start w-full p-3 bg-white shadow-sm totalArticulosFooter'>
        <div className='flex items-center justify-start w-1-3'>
          <span className='text-18'>
            {t("crear.facturaRec.articleTotalLabel")} {conceptos.length}
          </span>
        </div>

        <div className='flex items-center justify-end w-2-3'>
          {!sinValorar && (
            <div className='mr-4'>
              <span className='text-21'>
                {t("crear.facturaRec.priceTotalLabel")}{" "}
                <b>{formatCurrency(subtotal)}</b>
              </span>
            </div>
          )}

          <div>
            <Button
              className='large'
              onClick={handleGenerarPresupuesto}
            >
              {t("crear.facturaRec.generateLabel")} {title}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ArticulosSelected
